import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { formatDayMonth, formatTime, formatDayOfWeek } from "../lib/format";
import MapButton from "./MapButton";

export default function RideCard({ ride, isPast = false }) {
  const { day, month, year } = formatDayMonth(ride.ride_datetime);
  const weekday = formatDayOfWeek(ride.ride_datetime, true);
  const time = ride.arrival_time || formatTime(ride.ride_datetime);

  return (
    <Link
      to={`/ride/${ride.id}`}
      className="block ticket-card group"
      data-testid={`ride-card-${ride.id}`}
    >
      <div className="ticket-notch-top hidden sm:block" />
      <div className="ticket-notch-bottom hidden sm:block" />
      <div className="flex">
        {/* Date column */}
        <div
          className="w-[108px] shrink-0 flex flex-col items-center justify-center py-6 px-3 border-r border-dashed border-white/15"
          style={{ background: "rgba(0, 229, 255, 0.04)" }}
        >
          <div
            className="label-caps"
            style={{ color: isPast ? "#94A3B8" : "#39FF14" }}
            data-testid={`ride-weekday-${ride.id}`}
          >
            {weekday}
          </div>
          <div className="label-caps text-white/60 mt-1">{month}</div>
          <div
            className="font-display text-5xl sm:text-6xl leading-none mt-1"
            style={{ color: isPast ? "#94A3B8" : "#00E5FF" }}
          >
            {day}
          </div>
          <div className="label-caps mt-1">{year}</div>
        </div>

        {/* Body */}
        <div className="flex-1 p-4 sm:p-5 min-w-0">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <h3 className="font-display text-2xl sm:text-3xl text-white uppercase tracking-wide truncate">
                {ride.name}
              </h3>
              <div className="mt-2 flex items-center gap-2 text-sm text-white/80">
                <MapButton
                  address={ride.location}
                  size={18}
                  stopPropagation
                  testid={`ride-card-map-${ride.id}`}
                />
                <span className="truncate">{ride.location}</span>
              </div>
            </div>
            <div className="flex flex-col items-end gap-1 shrink-0">
              {isPast ? (
                <span
                  className="label-caps px-2 py-1 border border-white/15 text-white/70"
                  data-testid="ride-past-tag"
                >
                  Passado
                </span>
              ) : (
                <span
                  className="label-caps px-2 py-1 border"
                  style={{ color: "#39FF14", borderColor: "rgba(57,255,20,0.35)" }}
                  data-testid="ride-upcoming-tag"
                >
                  Próximo
                </span>
              )}
              {ride.is_official === false && (
                <span
                  className="label-caps text-[10px] px-1.5 py-0.5 border"
                  style={{ color: "#F59E0B", borderColor: "rgba(245,158,11,0.35)" }}
                  data-testid={`ride-unofficial-tag-${ride.id}`}
                >
                  Encontro Livre
                </span>
              )}
            </div>
          </div>

          <div className="mt-4 flex items-center justify-between">
            <div className="flex items-center gap-2 text-sm text-white/70">
              <Clock size={14} />
              <span>
                {ride.arrival_time} → {ride.departure_time}
              </span>
            </div>
            <div
              className="flex items-center gap-1 font-body text-xs uppercase tracking-wider text-white group-hover:text-[#00E5FF] transition-colors"
              style={{ letterSpacing: "0.15em" }}
            >
              Detalhes <ArrowRight size={14} />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
